<template>
  <div class="subject">
    <div class="subject_title01" v-if="cardOri == 0">
      <div class="subject_card">
        <img class="img_shu01" :src="frontCoverH" alt="" />
        <img class="img_shu02" :src="faceImage" alt="" />
      </div>
      <div class="subject_card_hit">卡片尺寸： 85.6 x 54mm</div>
    </div>
    <div class="subject_title02" v-if="cardOri == 1">
      <div class="subject_card">
        <img class="img_shu01" :src="frontCoverV" alt="" />
        <img class="img_shu02" :src="faceImage" alt="" />
      </div>
      <div class="subject_card_hit">卡片尺寸： 54 x 85.6mm</div>
    </div>
    <div class="subject_main">
      <div class="title">选择反面背景</div>
      <div class="subject_main_button">
        <div
          class="item"
          :class="{ selected: selectedIndex === index }"
          v-for="(item, index) in buttonList"
          :key="index"
          @click="selectItem(index)"
        >
          <img class="item_img" :src="item.thumbnailPath" alt="" />
          <div class="name">{{ item.imageName }}</div>
        </div>
      </div>
    </div>
    <div class="subject_foot">
      <div class="bottom_button">
        <div class="left_button" @click="back()">
          <div class="element">←</div>
          <div class="element">上一步</div>
        </div>
        <div class="right_button" @click="next()">
          <div class="element">→</div>
          <div class="element">预览</div>
        </div>
      </div>
    </div>
    <!-- 加载 -->
    <div v-show="loading">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">{{ promptt }}</p>
      </div>
    </div>
  </div>
</template>
<script>
const config = require("@/common/config");
import axios from "axios";
export default {
  name: "selectReverseSide_customs_ccb",
  data() {
    return {
      cardOri: "",
      targetImg: "",
      layoutTag: "背面", //仅用于此页面
      faceImage: "",
      imageTag: "",
      frontCoverH: "../../../../static/ccb/ccb反横.png",
      frontCoverV: "../../../../static/ccb/ccb反竖.png",
      buttonList: [],
      selectedIndex: 0, // 初始没有选中项
      loading: false,
      promptt: "背景更换中...",
      prompt: "",
      phone: "",
      process: "",
      taskId: "",
      delImageUrl: "",
    };
  },
  mounted() {
    this.prompt = this.$route.params.prompt;
    // this.phone = this.$route.params.phone;
    this.process = this.$route.params.process;
    this.taskId = this.$route.params.taskId;
    this.delImageUrl = this.$route.params.delImageUrl;

    this.cardOri = localStorage.getItem("cardOri_ccb");
    console.log("cardOri--->", this.cardOri);
    this.targetImg = localStorage.getItem("targetImg_ccb");
    this.getInit();
    this.getTopic();
  },
  methods: {
    showLoading: function () {
      this.loading = true;
      // 添加2秒计时器，2秒后自动关闭loading
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
    hideLoading: function () {
      this.loading = false;
    },
    // 选择
    selectItem(index) {
      this.showLoading();
      this.selectedIndex = index;
      this.main_button(this.buttonList[index]);
    },
    main_button(data) {
      console.log(data);
      this.faceImage = data.imagePath;
      // this.faceImage = data.thumbnailPath;
      this.imageTag = data.imageTag;
    },
    getInit() {
      // 初始化
      if (this.cardOri == 1) {
        this.faceImage = "../../../../static/ccb/橙色竖.png";
        this.imageTag = "0004#H0001";
      } else if (this.cardOri == 0) {
        this.faceImage = "../../../../static/ccb/橙色横.png";
        this.imageTag = "0004#H0001";
      }
    },
    // 获取主题列表
    getTopic() {
      let params = `?bankCode=${localStorage.getItem("bankCode")}`;
      axios.get(config.config_ccb.getTopic + params).then((res) => {
        console.log("getTopic--->", res);
        if (res.data.code == 200) {
          let arr = res.data.data;
          let obj = arr.find((item) => item.id === 5);
          console.log(obj);
          this.getTopicImages(obj.id);
        } else {
          console.log("获取主题失败");
        }
      });
    },
    // 获取图片列表
    getTopicImages(id) {
      let params =
        `?bankCode=${localStorage.getItem("bankCode")}` +
        `&` +
        `topicId=${id}` +
        `&` +
        `layoutTag=${this.layoutTag}` +
        `&` +
        `imageLayout=${this.cardOri}`;
      axios.get(config.config_ccb.getTopicImages + params).then((res) => {
        console.log("getTopicImages--->", res);
        if (res.data.code == 200) {
          this.buttonList = res.data.data;
        } else {
          console.log("获取列表失败");
        }
      });
    },

    back() {
      // this.$router.push({
      //   name: "AIEditCardface_ccb",
      //   params: {
      //     prompt: this.prompt,
      //     process: this.process,
      //     taskId: this.taskId,
      //     delImageUrl: this.delImageUrl,
      //   },
      // });
      if (this.process == 0) {
        // 文生图
        this.$router.replace({
          name: "AItext_to_image_ccb",
          params: {
            taskId: this.taskId,
            // phone: this.phone,
            backoff: 1,
          },
        });
      } else if (this.process == 1) {
        // 图文生图
        this.$router.replace({
          name: "AIimage_text_to_image_ccb",
          params: {
            taskId: this.taskId,
            // phone: this.phone,
            backoff: 1,
            style: this.style,
            prompt: this.prompt,
          },
        });
      } else if (this.process == 2) {
        // 图生图
        this.$router.replace({
          name: "AIimage_to_image_ccb",
          params: {
            taskId: this.taskId,
            // phone: this.phone,
            backoff: 1,
            style: this.style,
          },
        });
      } else {
        // 退回主页面
        this.$router.replace({
          name: "home_ccb",
          params: {
            taskId: this.taskId,
            // phone: this.phone,
            backoff: 1,
          },
        });
      }
    },
    next() {
      this.$router.push({
        name: "uploadCardface_ai_ccb",
        params: {
          imageTag: this.imageTag,
          targetImg: this.targetImg,
          cardOri: this.cardOri,
          faceImage: this.faceImage,
          taskId: this.taskId,
          delImageUrl: this.delImageUrl,
          process: this.process,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.subject {
  width: 100%;
  height: 45rem;
  .subject_title01 {
    padding-top: 4rem;
    width: 100%;
    height: 22rem;
    background-color: #f8f9fc;
    .subject_card {
      width: 20rem;
      height: 12.6rem;
      margin: auto;
      position: relative;
      .img_shu01 {
        border: 1px solid #0d1632;
        border-radius: 0.5rem;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      .img_shu02 {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .subject_card_hit {
      margin-top: 1rem;
      text-align: center;
      font-size: 0.8rem;
      color: darkgray;
    }
  }
  .subject_title02 {
    padding-top: 2rem;
    width: 100%;
    height: 22rem;
    background-color: #f8f9fc;
    .subject_card {
      width: 10.12rem;
      height: 16rem;
      margin: auto;
      position: relative;
      .img_shu01 {
        border: 1px solid #0d1632;
        border-radius: 0.5rem;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      .img_shu02 {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .subject_card_hit {
      margin-top: 1rem;
      text-align: center;
      font-size: 0.8rem;
      color: darkgray;
    }
  }
  .subject_main {
    margin-bottom: 3rem;
    .title {
      width: 100%;
      height: 3rem;
      background: linear-gradient(to top, #ffffff, #cce3f9);
      border-radius: 1.5rem 1.5rem 0 0;
      text-align: center;
      color: #0d1632;
      font-size: 1rem;
      font-weight: 900;
    }
    .subject_main_button {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 25%;
        flex: 0 0 25%; /* 每个子元素占据25%宽度 */
        box-sizing: border-box;
        text-align: center;
        /* 确保元素可以显示边框 */
        box-sizing: border-box;
        cursor: pointer;
        border: 2px solid transparent; /* 预置透明边框避免布局抖动 */
        transition: border-color 0.2s ease; /* 可选：过渡效果 */
        .item_img {
          width: 4rem;
          height: 4rem;
        }
        .name {
          font-size: 0.6rem;
          width: 3rem;
          margin: auto;
        }
      }
      .item.selected {
        border: 2px solid #093695;
        border-radius: 0.6rem;
        outline: none;
      }
    }
  }
  .subject_foot {
    padding: 0 1rem;
    .bottom_button {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .left_button {
        width: 40%;
        height: 2.4rem;
        padding-top: 0.4rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        border: 1px solid #093695;
        border-radius: 1.2rem;
        .element {
          font-weight: 500;
          font-size: 1rem;
          color: #093695;
          font-family: "黑体", "Microsoft YaHei", sans-serif;
        }
      }
      .right_button {
        width: 50%;
        height: 2.4rem;
        padding-top: 0.4rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        // border: 1px solid #023bb6;
        background: linear-gradient(to right, #093695, #0d1632);
        border-radius: 1.2rem;
        .element {
          font-weight: 500;
          font-size: 1rem;
          color: white;
          font-family: "黑体", "Microsoft YaHei", sans-serif;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CCB_demo/AIGC/SelectReverseSide_ningbo.vue